import { ApiService } from "../../constants";
import { HttpService } from "../../utilities";

interface GetMasterLevel {
  search?: string;
  userin?: string;
  scheduleid?: string;
  page?: number;
  size?: number;
}

export const getMasterLevel = ({
  search = "",
  page,
  size,
  scheduleid = "",
  userin = "",
}: GetMasterLevel) => {
  return HttpService.get(
    `${
      ApiService.icdc.module.masterLevel.getList
    }?search=${search}&page=${page}&userin=${userin || ""}`
  );
};

export const postMasterLevel = (data) => {
  return HttpService.post(ApiService.icdc.module.masterLevel.add, data);
};

export const editMasterLevel = (data) => {
  return HttpService.post(ApiService.icdc.module.masterLevel.update, data);
};

export const deleteMasterLevel = (data) => {
  return HttpService.post(ApiService.icdc.module.masterLevel.delete, data);
};

export const saveImage = (data) => {
  return HttpService.post(ApiService.icdc.module.file.uploadImage, data);
};
